module.exports = __webpack_public_path__ + "static/media/21stCenturyBanner.5cdfc30a.png";